export default {
  buttons: {
    skip: 'Ignorar',
    back: 'Anterior',
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar dados',
    payment: {
      pending: 'O seu pagamento está a ser processado...',
      success: '👍 O seu pagamento foi processado com sucesso. Obrigado!',
      error:
        '⁉️Ocorreu um problema com o seu pagamento ou o processamento está a demorar mais do que o esperado. Tente atualizar a página durante 1 minuto; caso contrário, contacte o suporte técnico.',
    },
  },
};
